import React from 'react';

function Footer() {
    return (
      <footer className="footer">
                <div className="footer-container">
          <div className="address">
            <strong>Адрес:</strong>
            <p>Новослободская улица, 73, Москва, Россия, 127055 </p>
          </div>
          <div className="phone">
            <strong>Телефон:</strong>
            <p>+7 (495) 961-41-22</p>
          </div>
          <div className="email">
            <strong>E-mail:</strong>
            <p>arts.association.2014@gmail.com</p>
          </div>
        </div>
      </footer>
    );
  }

  export default Footer;
